import { render } from "./person-nationality-detail.vue?vue&type=template&id=21047fea"
import script from "./person-nationality-detail.vue?vue&type=script&lang=js"
export * from "./person-nationality-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__